export default {
  data() {
    return {
      permissions: JSON.parse(localStorage.getItem('permissions'))
    }
  },
  methods: {
    hasPermission(permissionCode) {
      return this.permissions.admin || this.permissions.permissions.includes(permissionCode)
    },
    hasAnyPermission(permissionArr) {
      return this.permissions.admin || permissionArr.some(elem => this.permissions.permissions.indexOf(elem) > -1)
    }
  }
}